var exports = {
  "k": "EmojiUploadModal.module__container___eG5pQ0",
  "i": "EmojiUploadModal.module__message___eG5pQ0",
};

module.exports = exports;
